import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {UpdateUserSelectedDate} from '@/actions/deviceActions';
import CalibrationLoadCellIcon from '@/assets/icons/CalibrationLoadCell.svg';
import CycleSetup2 from '@/assets/icons/CycleSetup2.svg';
import DeviceIcon from '@/assets/icons/Device.svg';
import WifiIcon from '@/assets/icons/SystemSettingsWifi.svg';
import Button from '@/components/button/Button';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';

import './BottomMenu.less';

@connect((store) => ({
  activeMenu: store.setupStore.activeMenu,

  // showWarning : store.setupStore.showWarning,
  // errorMessage : store.setupStore.errorMessage,
  // profileName : store.setupStore.profileName
}))
class BottomMenu extends Component {
  constructor(props) {
    super(props);
    // Initiate state for this component
    this.state = {
      systemSettingMenu: APPDATA.DEVICE_SETTING,
      showButtomMenu: [
        APPDATA.DEVICE_SETTING,
        APPDATA.GENERAL_SETTING,
        APPDATA.PRESSURE_SETTING,
        APPDATA.WIFI_SETTING,
        APPDATA.CALIBRATION_LOAD_CELL_SENSOR,
      ], // APPDATA.VOLUME_THRESHOLD_SETTING Removed on 29/09/22 due to Gray e-mail
    };
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    this.initialActiveMenu();
  }

  componentDidUpdate() {
    const {discardBottom} = this.props;
    const {menuClicked} = this.state;
    if (discardBottom && menuClicked) {
      this.menuSelection(menuClicked);
    }
  }

  // onClick(e, v) {
  //   let activeMenu;
  //   switch (e.currentTarget.id) {
  //     case APPDATA.DEVICE_SETTING:
  //       window.location.href = APPDATA.DEVICE_SETTING_ADDRESS;
  //       break;
  //     case APPDATA.GENERAL_SETTING:
  //       window.location.href = APPDATA.GENERAL_SETTING_ADDRESS;
  //       break;
  //     // case APPDATA.DISPLAY_SETTING:
  //     //     window.location.href = APPDATA.DISPLAY_SETTING_ADDRESS;
  //     //     break;
  //     // case APPDATA.PRESSURE_SETTING:
  //     //     window.location.href = APPDATA.PRESSURE_SETTING_ADDRESS;
  //     //     break;
  //     // Removed on 29/09/22 due to Gray e-mail
  //     // case APPDATA.VOLUME_THRESHOLD_SETTING:
  //     //     window.location.href = APPDATA.VOLUME_THRESHOLD_ADDRESS;
  //     //     break;
  //     case APPDATA.WIFI_SETTING:
  //       window.location.href = APPDATA.WIFI_SETTING_ADDRESS;
  //       break;
  //     case APPDATA.CALIBRATION_LOAD_CELL_SENSOR:
  //       window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS;
  //       break;
  //     default:
  //       break;
  //   }
  //   this.setState({
  //     systemSettingMenu: e.currentTarget.id,
  //   });
  // }

  onClick(e) {
    const {isShowConfirmationDialog, doConfirmationDialog, dispatch} = this.props;
    
    const navigateMenu = () => {
      dispatch(UpdateUserSelectedDate(''));
      this.menuSelection(e.target.id);
      this.setState({
        systemSettingMenu: e.target.id,
      });
    };

    if (isShowConfirmationDialog) {
      this.setState({menuClicked: e.target.id});
      doConfirmationDialog(navigateMenu);
    } else {
      navigateMenu();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  menuSelection = (menu) => {
    switch (menu) {
      case APPDATA.DEVICE_SETTING:
        window.location.href = APPDATA.DEVICE_SETTING_ADDRESS;
        break;
      // case APPDATA.DISPLAY_SETTING:
      //   window.location.href = APPDATA.DISPLAY_SETTING_ADDRESS;
      //   break;
      case APPDATA.GENERAL_SETTING:
        window.location.href = APPDATA.GENERAL_SETTING_ADDRESS;
        break;
      // case APPDATA.PRESSURE_SETTING:
      //     window.location.href = APPDATA.PRESSURE_SETTING_ADDRESS;
      //     break;
      // Removed on 29/09/22 due to Gray e-mail
      // case APPDATA.VOLUME_THRESHOLD_SETTING:
      //     window.location.href = APPDATA.VOLUME_THRESHOLD_ADDRESS;
      //     break;
      case APPDATA.WIFI_SETTING:
        window.location.href = APPDATA.WIFI_SETTING_ADDRESS;
        break;
      case APPDATA.CALIBRATION_LOAD_CELL_SENSOR:
        window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS;
        break;
      default:
        break;
    }
  };

  initialActiveMenu() {
    let activeMenu;
    switch (window.location.hash) {
      case APPDATA.DEVICE_SETTING_ADDRESS:
        activeMenu = APPDATA.DEVICE_SETTING;
        break;
      case APPDATA.GENERAL_SETTING_ADDRESS:
        activeMenu = APPDATA.GENERAL_SETTING;
        break;
      // case APPDATA.DISPLAY_SETTING_ADDRESS:
      //   activeMenu = APPDATA.DISPLAY_SETTING;
      //   break;
      // case APPDATA.PRESSURE_SETTING_ADDRESS:
      //     activeMenu = APPDATA.PRESSURE_SETTING;
      //     break;
      // Removed on 29/09/22 due to Gray e-mail
      // case APPDATA.VOLUME_THRESHOLD_ADDRESS:
      //     activeMenu = APPDATA.VOLUME_THRESHOLD_SETTING;
      //     break;
      case APPDATA.WIFI_SETTING_ADDRESS:
        activeMenu = APPDATA.WIFI_SETTING;
        break;
      case APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS:
        activeMenu = APPDATA.CALIBRATION_LOAD_CELL_SENSOR;
        break;
      default:
        break;
    }
    this.setState({
      systemSettingMenu: activeMenu,
    });
  }

  generateTitleMenu() {
    const {systemSettingMenu} = this.state;
    return (
      // <div className="col-md-3 colTitleButtomMenu ">
      <div className={`${APPSTYLE.COLUMN_3}colTitleButtomMenu`}>
        <div className="titleButtomMenu center">
          <span>{systemSettingMenu}</span>
        </div>
      </div>
    );
  }

  generateButton(id, onClick, icon) {
    const menu = this.generateTitleMenu();
    const {systemSettingMenu} = this.state;
    return (
      <>
        {systemSettingMenu !== id && (
          <div className={`${APPSTYLE.COLUMN_1}colButtonBottomMenu`}>
            <Button
              id={id}
              onClick={onClick}
              className="buttonBottomMenu"
              icon={icon}
            />
          </div>
        )}
        {systemSettingMenu === id && menu}
      </>
    );
  }

  genereteBottomMenu() {
    const {activeMenu} = this.props;
    const {showButtomMenu} = this.state;
    if (PC_COMMON_FUNCTION.IsInArray(activeMenu, showButtomMenu)) {
      const hideClassname =
        activeMenu === APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE ? 'bottomMenu-hide' : 'bottomMenu-show';
      return (
        <div
          className={`bottomMenu footer ${hideClassname}`}
          id="bottom-menu"
        >
          {' '}
          {/* navbar-fixed-bottom */}
          {this.generateButton(APPDATA.DEVICE_SETTING, this.onClick, DeviceIcon)}
          {this.generateButton(APPDATA.GENERAL_SETTING, this.onClick, CycleSetup2)}
          {/* {this.generateButton(APPDATA.PRESSURE_SETTING, this.onClick, PressureIcon)} */}
          {/* {this.generateButton(APPDATA.VOLUME_THRESHOLD_SETTING, this.onClick, ThresholdIcon)}  Removed on 29/09/22 due to Gray e-mail */}
          {this.generateButton(APPDATA.CALIBRATION_LOAD_CELL_SENSOR, this.onClick, CalibrationLoadCellIcon)}
          {this.generateButton(APPDATA.WIFI_SETTING, this.onClick, WifiIcon)}
        </div>
      );
    }
    return null;
  }

  render() {
    return this.genereteBottomMenu();
  }
}

BottomMenu.propTypes = {
  activeMenu: PropTypes.string,
  discardBottom: PropTypes.bool,
  isShowConfirmationDialog: PropTypes.bool,
  doConfirmationDialog: PropTypes.func,
  dispatch: PropTypes.func,
};

BottomMenu.defaultProps = {
  activeMenu: 'None',
  discardBottom: false,
  isShowConfirmationDialog: false,
  doConfirmationDialog: () => {},
  dispatch: () => {},
};

export default BottomMenu;
